// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RacFooter_wrapper__w1dqW"};